import React from 'react';
import FormattedNumber from '../FormattedNumber.jsx';

export default function Totals (props) {
    return (<div className="totals">
        <div className="total-item">
            <span className="label">Subtotal (<em>{props.unit_count} {props.unit_count > 1 ? 'units': 'unit'}</em>)</span>
            <span className="price">
                <FormattedNumber value={props.sub_total} currency={props.currency} />
            </span>
        </div>
        <div className="total-item">
            <span className="label">Your Discount</span>
            <span className="price">
                <FormattedNumber value={props.discount * -1} currency={props.currency} />
            </span>
        </div>
        {props.warranties
            ? <div className="total-item">
                <span className="label">Warranties</span>
                <span className="price">
                    <FormattedNumber value={props.warranties} currency={props.currency} />
                </span>
            </div>
            : null
        }
        <div className="total-item">
            <span className="label">Shipping &amp; Handling</span>
            <span className="price">
                <FormattedNumber value={props.shipping} currency={props.currency} />
            </span>
        </div>
        <div className="total-item">
            <strong className="label">Grand Total</strong>
            <strong className="price">
                <FormattedNumber value={props.grand_total} currency={props.currency} />
            </strong>
        </div>
        <p><em><small>*Taxes may be added to final invoice when applicable.</small></em></p>
    </div>);
};
